import Vue from 'vue';
import Router from 'vue-router';
import * as wxWork from "@/dianwuyi/wx-work"
import {setAuthCode} from "@/dianwuyi/wx-work";
import {uuid} from "@/dianwuyi/utils";
import cookie from 'js-cookie'

import Layout from '@/layout/index'

Vue.use(Router);

const routes = [
    // {
    //     path: '*',
    //     redirect: '/goods'
    // },
    {
        path: '/sale_resource',
        name: 'sale_resource',
        component: () => import('./view/sale_resource'),
        meta: {
            title: '售前素材'
        }
    },
    {
        path: '/service_resource',
        name: 'service_resource',
        component: () => import('./view/service_resource'),
        meta: {
            title: '售后素材'
        }
    },
    {
        path: "/user",
        name: 'user',
        component: () => import('./view/user'),
        meta: {
            title: '会员中心'
        }
    },
    {
        name: 'cart',
        component: () => import('./view/cart'),
        meta: {
            title: '购物车'
        }
    },
    {
        path: '/work',
        name: 'work',
        component: Layout,
        redirect: '/work/index',
        meta: {
            title: '工作台'
        },
        children: [
            {
                path: 'index',
                name: 'WorkIndex',
                component: (resolve) => require(['@/view/work/index'], resolve),
                meta: {
                    title: '工作台'
                }
            },
            {
                path: 'list',
                name: 'WorkUserList',
                component: (resolve) => require(['@/view/work/list'], resolve),
                meta: {
                    title: '客户列表',
                },
            },
            {
                path: 'detail',
                name: 'WorkUserDetail',
                component: (resolve) => require(['@/view/work/detail'], resolve),
                meta: {
                    title: '客户详情',
                },
            },
            {
                path: 'addMemo',
                name: 'WorkUserDetail_AddMemo',
                component: (resolve) => require(['@/view/work/addMemo'], resolve),
                meta: {
                    title: '填写跟进记录',
                },
            },
            {
                path: 'addReserv',
                name: 'WorkUserDetail_AddReserv',
                component: (resolve) => require(['@/view/work/addReserv'], resolve),
                meta: {
                    title: '预约回访',
                },
            },
            {
                path: 'search',
                name: 'WorkUserSearch',
                component: (resolve) => require(['@/view/work/search'], resolve),
                meta: {
                    keepAlive: true,
                    title: '搜索客户',
                },
            },
            {
                path: 'jump',
                name: 'WorkUserJump',
                component: (resolve) => require(['@/view/work/jump'], resolve),
                meta: {
                    keepAlive: true,
                    title: '客户详情',
                },
            },
        ]
    },
    {
        path: '/report',
        name: 'report',
        component: Layout,
        redirect: '/report/index',
        meta: {
            title: '报表'
        },
        children: [
            {
                path: 'index',
                name: 'ReportIndex',
                component: (resolve) => require(['@/view/report/index'], resolve),
                meta: {
                    title: '报表'
                }
            },
            {
                path: 'list',
                name: 'ReportList',
                component: (resolve) => require(['@/view/report/list'], resolve),
                meta: {
                    title: '数据'
                }
            },
        ]
    },
    {
        path: '/manager',
        name: 'manager',
        component: Layout,
        redirect: '/manager/index',
        meta: {
            title: '管理'
        },
        children: [
            {
                path: 'index',
                name: 'ManagerIndex',
                component: (resolve) => require(['@/view/manager/index'], resolve),
                meta: {
                    title: '管理'
                }
            },
            {
                path: 'funnel',
                name: 'ManagerFunnel',
                component: (resolve) => require(['@/view/manager/funnel/index'], resolve),
                meta: {
                    title: '销售漏斗'
                }
            },
            {
                path: 'funnel_list',
                name: 'ManagerFunnelList',
                component: (resolve) => require(['@/view/manager/funnel/list'], resolve),
                meta: {
                    title: '客户列表'
                }
            },
            {
                path: 'userData',
                component: (resolve) => require(['@/view/manager/userData/index'], resolve),
                meta: {
                    title: '资料完善'
                }
            },
            {
                path: 'userData_list',
                component: (resolve) => require(['@/view/manager/userData/list'], resolve),
                meta: {
                    title: '资料完善列表'
                }
            },
            {
                path: 'pause_list',
                component: (resolve) => require(['@/view/manager/userData/pause_list'], resolve),
                meta: {
                    title: '暂停跟进列表'
                }
            },

            {
                path: 'userIndustryReport',
                component: (resolve) => require(['@/view/manager/userData/userIndustryReport'], resolve),
                meta: {
                    title: '行业数据'
                }
            },
        ]
    }
];
const whiteList = ['/work']
// add route path
routes.forEach(route => {
    route.path = route.path || '/' + (route.name || '');
});

const router = new Router({mode: "hash", routes: routes});

// 去除链接中的code和state
function delCodeandstate(to) {
    let path = ''
    for (const i in to.query) {
        if (i != 'code' && i != 'state') {
            path = path + '&' + i + '=' + to.query[i]
        }
    }
    path = path == '' ? '' : path.substring(1, path.length)
    path = path == '' ? '' : '/?' + path
    return path
}

router.beforeEach(async (to, from, next) => {
        const token = wxWork.getToken() // 获取token
        const title = to.meta && to.meta.title;
        if (title) {
            document.title = title;
        }
        let isCur = false // 是否免登录
        // 判断白名单

        for (const i of whiteList) {
            if (to.path == i) {
                isCur = true
            }
        }
        // next()
        // return
        if (isCur) {
            next() // 白名单内不做登录判断，直接next
        } else if (location.href.indexOf("?code") != -1 && location.href.indexOf("&state") != -1) {
            //oauth回调
            let pars = location.href.substring(location.href.indexOf("?") + 1, location.href.indexOf("#"))
            let _codeState = pars.split("&")
            let _code = _codeState[0].split("=")[1]
            await wxWork.setAuthCode(_code)
            window.location.href = cookie.get("beforePath")
        } else if (token) {
            next()
        } else { // 未登录，没有token，进行授权登录
            cookie.set("beforePath", location.href)
            const redirectUrl = encodeURIComponent(location.origin) // 授权登陆后的回调地址，需要进行encodeURIComponent处理
            let _authUrl = await wxWork.getAuthUrl(redirectUrl)
            window.location.href = _authUrl
        }
    }
)

export default router